const url = decodeURIComponent(window.location.href);
const decodeURL = str => decodeURIComponent(str.replace(/\+/g, ' '));

const _getQueryParam = name => new URLSearchParams(window.location.search).get(name);

if (!sessionStorage.getItem('FirstPage-Session')) {
    sessionStorage.setItem('FirstPage-Session', url);
}

if (!sessionStorage.getItem('sessionStartTime')) {
    const sessionStartTime = new Date().toLocaleString('en-US', {day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false}).replace(',', '');
    sessionStorage.setItem('sessionStartTime', sessionStartTime);
}

if (!localStorage.getItem('sessionStartTime')) {
    const sessionStartTime = new Date().toLocaleString('en-US', {day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false}).replace(',', '');
    localStorage.setItem('sessionStartTime', sessionStartTime);
}


if (!localStorage.getItem('FirstPage-Browser')) {
    localStorage.setItem('FirstPage-Browser', url);
}


const setReferrer = (url, referrer) => {
    if(referrer){
        sessionStorage.setItem('ref', referrer) ;
    }
    else {
        sessionStorage.setItem('ref', "Direct") ;
    }
};

if (!sessionStorage.getItem('ref')) {
    setReferrer(url, document.referrer);
}

const setSearchQuery = () => {
    if (url.includes( "/search")) {
        const searchQuery = _getQueryParam("q");
        if (searchQuery) {
            const decodedQuery = decodeURL(searchQuery);
            const searchQueries = JSON.parse(sessionStorage.getItem("SearchQueries") || "[]");
            searchQueries.push(decodedQuery);
            sessionStorage.setItem("SearchQueries", JSON.stringify(searchQueries));
        }
    }
};


if(url.includes("/products")){
    sessionStorage.setItem('Placement', _getQueryParam('pl'));
    sessionStorage.setItem('PlacementIndex', _getQueryParam('_pos'));

    document.querySelector('#_placement').value = sessionStorage.getItem('Placement');
    document.querySelector('#_position').value = sessionStorage.getItem('PlacementIndex');
}

if(url.includes("/search")){
    setSearchQuery();
}

if(url.includes("/cart") && window.cartItemCount !== 0){
    document.getElementById('_first_page').value = sessionStorage.getItem('FirstPage-Session');
    document.getElementById('_first_page_local').value = localStorage.getItem('FirstPage-Browser');
    document.getElementById('_referrer').value = sessionStorage.getItem('ref');
    document.getElementById('_customerip').value = localStorage.getItem('ipAddress');
    document.getElementById('_sessionStart').value = `${localStorage.getItem('sessionStartTime') || ''} | ${sessionStorage.getItem('sessionStartTime') || ''}`.trim();
    document.getElementById('_search_data').value = sessionStorage.getItem('SearchQueries');

}

// console.log('FirstPage:', sessionStorage.getItem('FirstPage-Session'));
// console.log('FirstPage:', localStorage.getItem('FirstPage-Browser'));
// console.log('ref:', sessionStorage.getItem('ref'));
// console.log('Placement:', sessionStorage.getItem('Placement'));
// console.log('PlacementIndex:', sessionStorage.getItem('PlacementIndex'));
// console.log('SearchQueries:', sessionStorage.getItem('SearchQueries'));

